import { useAuth } from '../../context/AuthContext';
import { useMeQuery } from '../../queries/me';
import LeasingCalendar from './LeasingCalendar';
import ScheduleTiles from './ScheduleTiles';
import SchedulingRules from './SchedulingRules';
import { DEFAULT_TZ } from './time';
import { useWeek } from './useWeek';
import { Page } from './styled';
import { PageHeader } from '../../components';

const NO_RULES = {};

export default function Scheduling() {
  const { can } = useAuth();
  const { data: me } = useMeQuery();
  const scheduling = me?.organization?.scheduling || NO_RULES;
  const tz = scheduling.timezone || DEFAULT_TZ;
  const week = useWeek(tz);

  return (
    <Page>
      <PageHeader title="Calendar" subtitle="Tours and appointments booked by your team and your assistant." style={{ marginBottom: 0 }} />

      <ScheduleTiles tz={tz} today={week.today} enabled={Boolean(scheduling.enabled)} />
      <LeasingCalendar week={week} tz={tz} weeklyHours={scheduling.weeklyHours} canManage={can('manage_bookings')} />
      <SchedulingRules scheduling={scheduling} canEdit={can('manage_settings')} />
    </Page>
  );
}
